import requestAction from '../../utils/requestAction'

export const downloadComplaintInternalMessageFile = (complaintId: number, fileId?: string, complaintInternalMessageId?: number, handleResponse?: (file: any) => void) =>
  requestAction('COMPLAINT_INTERNAL_MESSAGE_DOWNLOADFILE')(
    `complaints/internal/message/download?complaintId=${complaintId}${complaintInternalMessageId ? '&complaintInternalMessageId=' + complaintInternalMessageId : ''}${fileId ? '&fileId=' + fileId : ''}`,
    'GET',
    undefined,
    {
      'Accept': 'application/pdf',
      'Content-Type': 'application/pdf',
    },
    'file',
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response) }) // handleResponse(response.fileName, response.file) })

